import { render, staticRenderFns } from "./income-list.vue?vue&type=template&id=41c2b7fb&scoped=true&"
import script from "./income-list.vue?vue&type=script&lang=js&"
export * from "./income-list.vue?vue&type=script&lang=js&"
import style0 from "./income-list.vue?vue&type=style&index=0&id=41c2b7fb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c2b7fb",
  null
  
)

export default component.exports